/**
 * Monero banhammer.
 */
export default class MoneroBan {
    constructor(ban) {
        Object.assign(this, ban);
    }
    toJson() {
        return Object.assign({}, this);
    }
    getHost() {
        return this.host;
    }
    setHost(host) {
        this.host = host;
        return this;
    }
    getIp() {
        return this.ip;
    }
    setIp(ip) {
        this.ip = ip;
        return this;
    }
    getIsBanned() {
        return this.isBanned;
    }
    setIsBanned(isBanned) {
        this.isBanned = isBanned;
        return this;
    }
    getSeconds() {
        return this.seconds;
    }
    setSeconds(seconds) {
        this.seconds = seconds;
        return this;
    }
}
